import React, { useState, useEffect } from 'react';
import { FaAmazon, FaArrowRight } from 'react-icons/fa';
import { getAmazonProducts } from '../utils/productUtils';

const HotItems = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    // Load products from localStorage or default data
    setProducts(getAmazonProducts());
  }, []);

  return (
    <div className="hot-items-container">
      <div className="section-container">
        <h2 className="section-title">Hot Items</h2>
        <p className="section-description">Check out these trending products handpicked by our team</p>
        
        <div className="product-grid">
          {products.map((product, index) => (
            <div className="product-card" key={index}>
              <div className="product-image-container">
                {product.imageUrl ? (
                  <img 
                    src={product.imageUrl} 
                    alt={product.productName} 
                    className="product-image" 
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = '/images/placeholder.jpg';
                    }}
                  />
                ) : (
                  <div className="product-image-placeholder">
                    <span>{product.productName.charAt(0)}</span>
                  </div>
                )}
                <div className="product-overlay">
                  <a 
                    href={product.amazonLink} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="view-button"
                  >
                    View on Amazon <FaArrowRight />
                  </a>
                </div>
              </div>
              <div className="product-info">
                <h3 className="product-name">{product.productName}</h3>
                <div className="product-price">{product.price}</div>
                <div className="product-actions">
                  <a 
                    href={product.amazonLink} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="amazon-btn"
                  >
                    <FaAmazon /> Buy Now
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="amazon-disclaimer">
          <p>We may earn a small commission from products purchased with Amazon links.</p>
        </div>
      </div>
    </div>
  );
};

export default HotItems; 